export const conditionallyCreateStyleObj = (vars) => Object.fromEntries(Object.entries(vars)
    .filter(([, value]) => {
    if (value === undefined || value === null) {
        return false;
    }
    if (typeof value === "string" && value.trim() === "") {
        return false;
    }
    return true;
})
    .map(([key, value]) => [
    key,
    typeof value === "string" ? value.trim() : value
]));
